import { render, staticRenderFns } from "./cancel-order.vue?vue&type=template&id=1c50427c&"
import script from "./cancel-order.vue?vue&type=script&lang=js&"
export * from "./cancel-order.vue?vue&type=script&lang=js&"
import style0 from "./cancel-order.vue?vue&type=style&index=0&id=1c50427c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports